<i18n>
{
	"en": {
		"paymentMethod": "Payment method",
		"automaticCalculation": "Calculation",
		"F": "Invoice",
		"A": "Settlement",
		"DefaultPriceCode": "Default pricecode",
		"title": "Economical"
	},
	"no":{
		"paymentMethod": "Opppgjørsform",
		"automaticCalculation": "Beregning",
		"F": "Faktura",
		"A": "Avregning",
		"DefaultPriceCode": "Standard priskode",
		"title": "Økonomisk"
	}
}
</i18n>

<template>
	<t-form-group :title="$t('title')">
		<t-text-input
			v-if="edisetup.defaultSettlementOrInvoiceCode"
			v-model="defaultSettlementOrInvoiceCode"
			disabled
			:label="$t('paymentMethod')"
		/>
		<t-text-input
			v-if="edisetup.defaultPriceCode"
			v-model="edisetup.defaultPriceCode"
			disabled
			:label="$t('DefaultPriceCode')"
		/>
		<div>
			<TLabeledValue
				:label="$t('automaticCalculation')"
				labelMarginBottom="11px"
			/>
			<t-switch
				v-model="edisetup.automaticCalculation"
				disabled
			/>
		</div>

	</t-form-group>
</template>

<script>
export default {
	name: 'Economical',
	props: {
		edisetup: Object
	},
	computed: {
		defaultSettlementOrInvoiceCode() {
			return ` ${this.edisetup.defaultSettlementOrInvoiceCode} ( ${this.$t(this.edisetup.defaultSettlementOrInvoiceCode)} )`;
			
		}
	}
};
</script>

<style>

</style>